const CACHE_NAME = 'fictiongenie-story-audio-v1';
const downloads = new Map();

// Keep completed downloads for reuse throughout this browser session.
export async function downloadStoryAudio(url, refresh = false, onProgress = () => {}) {
  if (!refresh && downloads.has(url)) {
    const saved = await downloads.get(url);
    onProgress(100);
    return saved;
  }
  if (refresh) downloads.delete(url);
  const job = (async () => {
    let cache;
    try {
      if (typeof caches !== 'undefined') cache = await caches.open(CACHE_NAME);
    } catch (_) { /* Playback still works when browser storage is unavailable. */ }
    let response;
    if (!refresh && cache) {
      try { response = await cache.match(url); } catch (_) { /* Download instead. */ }
    }
    let saveResponse;
    if (!response) {
      response = await fetch(url, { cache: refresh ? 'reload' : 'default' });
      if (!response.ok) throw new Error('Audio download failed. Please retry.');
      if (cache) saveResponse = response.clone();
    }
    const total = Number(response.headers?.get('content-length'));
    let blob;
    if (response.body?.getReader && total > 0) {
      const reader = response.body.getReader();
      const chunks = [];
      let received = 0;
      onProgress(0);
      try {
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          received += value.byteLength;
          onProgress(Math.min(99, Math.floor(received / total * 100)));
        }
      } finally { reader.releaseLock(); }
      blob = new Blob(chunks, { type: response.headers.get('content-type') || 'audio/wav' });
    } else {
      onProgress(null);
      blob = await response.blob();
    }
    if (!blob.size) throw new Error('The audio download was empty. Please retry.');
    if (cache && saveResponse) {
      try { await cache.put(url, saveResponse); } catch (_) { /* Optional storage. */ }
    }
    onProgress(100);
    return URL.createObjectURL(blob);
  })();
  downloads.set(url, job);
  try { return await job; }
  catch (error) {
    if (downloads.get(url) === job) downloads.delete(url);
    throw error;
  }
}
